import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AdminDomainServices } from '@/services/apis';

interface StateType {
  domains?: any[];
  loading?: boolean;
  error?: boolean;
  errorMessage?: string;
  totalRecords?: number;
  domainUsers: any[];
  totalUsersCount?: number;
  newlyCreatedDomain?: any;
}

const initialState: StateType = {
  domains: [],
  loading: true,
  error: false,
  errorMessage: '',
  totalRecords: 0,
  domainUsers: [],
  totalUsersCount: 0,
  newlyCreatedDomain: {}
};

export const fetchAllMasterDomains = createAsyncThunk(
  'admin/fetchAllDomain',
  async ({ page, rowsPerPage, searchDomainTerm }: any) => {
    const response = await AdminDomainServices.fetchDomains({
      pageNumber: page,
      pageSize: rowsPerPage,
      domainName: searchDomainTerm
    });

    return response;
  }
);

export const downloadDomain = createAsyncThunk('domain/downloadDomain', async () => {
  const response = await AdminDomainServices.downloadDomain();
  return response;
});

export const updateDomain = createAsyncThunk('domain/updateDomain', async (domainData: any) => {
  const { domainId, ...finalData } = domainData;
  const data = await AdminDomainServices.updateDomain(finalData, domainId);
  return data;
});

export const AdminDomainSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAllMasterDomains.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(fetchAllMasterDomains.fulfilled, (state, { payload }) => {
      return { ...state, domains: payload?.result.domains, totalRecords: payload?.totalRecords, loading: false };
    });
  }
});

export const AdminDomainSelector = (state: any) => state.admin;

export default AdminDomainSlice.reducer;
